<p-dialog
  header="New request"
  [visible]="true"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  styleClass="agent-request-dialog"
  (onHide)="close()"
>
  <div class="agent-request-form" data-cy="agent-request-dialog">
    <div class="agent-request-form__meta">
      <span class="agent-request-form__pill" data-cy="agent-request-mode">{{
        mode().label
      }}</span>
      <span class="agent-request-form__quote">
        Related quote: <strong>{{ quote().getDisplayId() }}</strong>
      </span>
    </div>

    <div class="agent-request-form__row">
      <div class="agent-request-form__field agent-request-form__field--agents">
        <span class="agent-request-form__label"
          >Agent: <span class="agent-request-form__required">*</span></span
        >
        <app-client-select
          data-cy="agent-request-agents"
          placeholder="Select agents"
          [clients]="agents()"
          [type]="agentType"
          (clientSelected)="onAgentsChange($event)"
        />
        @if (agentsWithoutEmail().length > 0) {
          <p-message
            severity="error"
            variant="simple"
            size="small"
            data-cy="agent-request-no-email"
          >
            No email address for {{ agentsWithoutEmailNames() }}. Add a contact
            person with an email to the agent.
          </p-message>
        }
      </div>
    </div>

    <span class="agent-request-form__label">Request details:</span>
    <div class="agent-request-form__details" data-cy="agent-request-details">
      <strong>{{ quote().getQuoteType().toUpperCase() }}</strong>
      @if (shipment()) {
        <span>{{ shipment() }}</span>
      }
      @if (route()) {
        <strong>{{ route() }}</strong>
      }
    </div>

    <div class="mail-editor">
      <div class="mail-editor__header">
        <span class="mail-editor__title">Message</span>
      </div>
      <div class="mail-editor__row">
        <span class="mail-editor__label">To agent:</span>
        <div class="mail-editor__value">
          <div class="mail-editor__field">
            <p-chip label="All agents emails" />
          </div>
        </div>
      </div>
      <div class="mail-editor__row">
        <span class="mail-editor__label">Subject:</span>
        <div class="mail-editor__value">
          <div class="mail-editor__field">
            <app-wysiwyg
              class="mail-editor__subject"
              data-cy="agent-request-subject"
              [showPlaceholders]="true"
              [placeholderIds]="agentPlaceholders"
              [showToolbarItems]="false"
              [value]="subject()"
              (valueChanged)="onSubjectChange($event)"
            />
          </div>
        </div>
      </div>
      <div class="mail-editor__row mail-editor__row--message">
        <span class="mail-editor__label">Message:</span>
        <div class="mail-editor__value">
          <app-wysiwyg
            data-cy="agent-request-message"
            [showPlaceholders]="true"
            [placeholderIds]="agentPlaceholders"
            [showToolbarItems]="true"
            [minHeight]="true"
            [value]="message()"
            (valueChanged)="onMessageChange($event)"
          />
        </div>
      </div>
      <div class="mail-editor__row mail-editor__row--attachments">
        <span class="mail-editor__label">Attachments:</span>
        <div class="mail-editor__value">
          <app-upload
            label="Add files"
            [multiple]="true"
            [outlined]="true"
            (fileUploaded)="addAttachment($event)"
          />
          <div class="mail-editor__attachments">
            @for (attachment of attachments(); track attachment) {
              <p-chip
                [removable]="true"
                removeIcon="pi pi-times"
                (onRemove)="removeAttachment(attachment)"
              >
                <i class="pi pi-paperclip" aria-hidden="true"></i>
                {{ fileName(attachment) }}
              </p-chip>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #footer>
    <button
      pButton
      type="button"
      variant="text"
      data-cy="agent-request-cancel"
      (click)="close()"
    >
      <i class="pi pi-times"></i>
      <span>Cancel</span>
    </button>
    <button
      pButton
      type="button"
      data-cy="agent-request-send"
      [disabled]="!canSend()"
      [loading]="sending()"
      (click)="send()"
    >
      <i class="pi pi-send"></i>
      <span>Send request</span>
    </button>
  </ng-template>
</p-dialog>
